import { RootState } from "../../../redux-store";

export const selectShouldShowUpdateModal = (state: RootState) =>
  state.app.nativeVersion.shouldShowUpdateModal;
